import { getLocalStorage } from "./helper";

export const userInfo = () => JSON.parse(getLocalStorage("userInfo"));
